// GENERATED CODE - DO NOT EDIT
export const FertilityCycleMedicationTypeMap = {
    GONAL_F: 'gonal_f',
    MENOPUR: 'menopur',
    CETROTIDE: 'cetrotide',
    ANY: 'any',
};
//# sourceMappingURL=fertility_cycle_medication_type.js.map